import { styled } from '@mui/material';

export const Content = styled('article')<{ upSMPaddingLeft?: number }>`
  grid-area: content;
  overflow: hidden;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding-left: ${({ theme, upSMPaddingLeft = 0 }) =>
      theme.spacing(upSMPaddingLeft)};
  }
`;

export const ExternalLinkWrapper = styled('div')`
  grid-area: ext-link;
  margin-top: ${({ theme }) => theme.spacing(4)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin-left: ${({ theme }) => theme.spacing(33)};
  }
`;
